<template>
  <div class="admin-payments">
    <header-title title="Historial de Impresión"></header-title>

    <br />
    <v-row>
      <v-col cols="12" sm="6" md="3" class="py-0 py-sm-1">
        <date-picker-range @updateDates="updateDates"></date-picker-range>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
          label="Buscar"
          v-model="search"
          class="select-box"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-select
          v-model="tableQRSelected"
          :items="activesQR"
          item-text="table"
          item-value="table"
          label="Mesa"
          class="select-box"
          dense
          outlined
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="filteredPrinter"
          class="elevation-1 payments-table"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
        >
          <template v-slot:[`item.data.time`]="{ item }">
            <div style="display:flex;">
              <div>
                {{ item.data.time }}
              </div>
            </div>
          </template>
          <template v-slot:[`item.data`]="{ item }">
            <div style="display:flex;">
              <div>
                {{ JSON.stringify(item.data) }}
              </div>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import { PrinterHistoryTableHeader } from "@/utils/tableHeaderconstants.js";
import DatePickerRange from "@/components/common/DatePickerRange";
import HeaderTitle from "@/components/admin/common/HeaderTitle";
import { getPrinterHisotryByDateRange } from "@/collections/printerHistory";
import { qrCollection } from "@/collections/qrs";

export default {
  name: "Printer-History",
  components: { DatePickerRange, HeaderTitle },
  data() {
    return {
      printerHistoryCollection: [],
      search: "",
      tableQRSelected: "",
      headers: [...PrinterHistoryTableHeader]
    };
  },
  firestore() {
    return {
      qrCollection: qrCollection.where("active", "==", true).orderBy("table")
    };
  },
  computed: {
    activesQR() {
      let qr = [...this.qrCollection];
      qr = qr.sort((a, b) => {
        return a.table.localeCompare(b.table, undefined, {
          numeric: true,
          sensitivity: "base"
        });
      });
      return [{ id: "", table: "todas" }, ...qr];
    },
    filteredPrinter() {
      let _printer = [...this.printerHistoryCollection];

      if (this.tableQRSelected !== "" && this.tableQRSelected !== "todas") {
        _printer = _printer.filter(printer => {
          return (
            printer.data.id.toLowerCase() === this.tableQRSelected.toLowerCase()
          );
        });
      }

      return _printer;
    }
  },
  methods: {
    updateDates(dates) {
      if (dates.length === 1 || dates[0] === dates[1]) {
        this.updateOneDate(dates);
        return;
      }

      if (dates.length === 2) {
        this.updateTwoDates(dates);
      }
    },
    async updateOneDate(dates) {
      let date1 = this.formatDateTime2(dates[0]);
      let date2 = this.formatDateTime2(moment(dates[0]).add(1, "days"));

      try {
        this.printerHistoryCollection = await getPrinterHisotryByDateRange(
          date1,
          date2
        );
      } catch (error) {
        this.setlogError(
          "get_printer_hisotry",
          "Error getting documents",
          error.stack,
          this.$options.name
        );
      }
    },
    async updateTwoDates(dates) {
      let date1 = this.formatDateTime2(dates[0]);
      let date2 = this.formatDateTime2(dates[1]);

      try {
        this.printerHistoryCollection = await getPrinterHisotryByDateRange(
          date1,
          date2
        );
      } catch (error) {
        this.setlogError(
          "get_printer_hisotry",
          "Error getting documents",
          error.stack,
          this.$options.name
        );
      }
    }
  }
};
</script>

<style scoped></style>
